// O SKU coringa "9999" (PEÇA DIVERSA — BALCÃO, migração 016) é a válvula da
// fila: fecha a venda sem cadastro, MAS exige observação com a peça real —
// o banco recusa sem ela (registrar_venda v6). Este módulo é a mesma régua no
// cliente, para o vendedor descobrir ANTES de apertar o botão, não no erro.

export const SKU_CORINGA = '9999';

export function contemCoringa(itens: Array<{ sku: string }>): boolean {
  return itens.some((i) => i.sku === SKU_CORINGA);
}

/**
 * A venda pode fechar? Sem coringa no carrinho, sempre. Com coringa, só com
 * descrição de verdade — espaços não contam, e menos de 5 caracteres não
 * descrevem peça nenhuma ("ok" não ajuda a auditoria de amanhã).
 *
 * Desde a migração 041 a descrição é POR LINHA: cinco peças diversas na mesma
 * venda são cinco linhas, cada uma com a sua. A observação da venda continua
 * valendo como alternativa — é o caminho de quem vende UMA peça diversa e
 * descreve ali, e é o que já está gravado nas vendas antigas.
 *
 * A régua: TODA linha de coringa precisa estar coberta, pela própria descrição
 * ou pela observação da venda. Basta uma muda para a venda não fechar — o
 * banco recusa igual (registrar_venda v11), e é melhor descobrir aqui.
 */
export function observacaoCobreCoringa(
  itens: Array<{ sku: string; descricao_avulsa?: string }>,
  observacao: string,
): boolean {
  const coringas = itens.filter((i) => i.sku === SKU_CORINGA);
  if (coringas.length === 0) return true;
  if (observacao.trim().length >= 5) return true;
  return coringas.every((i) => (i.descricao_avulsa ?? '').trim().length >= 5);
}

/**
 * O nome de um item JÁ VENDIDO, na ordem em que a verdade mora:
 *
 *  1. `descricao_avulsa` — a PEÇA DIVERSA descrita na linha (041). Vem
 *     primeiro porque nela o produto é o coringa 9999, cuja descrição
 *     ("PEÇA DIVERSA — BALCÃO") não diz nada sobre o que o cliente levou.
 *  2. a descrição do produto cadastrado.
 *  3. o aviso de peça removida do catálogo — o histórico da venda não some
 *     junto com o cadastro, e a linha precisa dizer isso em vez de ficar vazia.
 */
export function nomeDoItemVendido(item: {
  descricao_avulsa?: string | null;
  /** Item já GRAVADO (aba Vendas): a descrição vem do produto. */
  products?: { descricao: string } | null;
  /** Item de CARRINHO (aba Vender): a descrição já está na mão. */
  descricao?: string | null;
}): string {
  const avulsa = (item.descricao_avulsa ?? '').trim();
  if (avulsa) return avulsa;
  return item.products?.descricao ?? item.descricao ?? '(peça removida do catálogo)';
}

/** A linha é de peça diversa? Decide o que a sanfona pode mostrar. */
export function ehItemAvulso(item: { descricao_avulsa?: string | null }): boolean {
  return (item.descricao_avulsa ?? '').trim().length > 0;
}
